import { useState } from "react";

import { useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAutocompleteQueryKeys } from "./queryKeyFactory";

const MAX_RESULTS = 8;

const useCompanyAutocompleteCustomFetch = (limit = MAX_RESULTS, withDataCredits: boolean = false) => {
    const queryClient = useQueryClient();
    const [isLoading, setLoading] = useState(false);

    const getListItems = async (term: string) => {
        setLoading(true);

        try {
            const data = await queryClient.ensureQueryData({
                queryKey: companyAutocompleteQueryKeys.companyAutocomplete(term),
                queryFn: async ({ signal }) => {
                    return salesApiService.getAutocompleteCompanies(
                        { term, size: limit, withDataCredits },
                        {
                            cancellation: signal,
                        },
                    );
                },
                staleTime: Infinity,
            });
            return data;
        } catch {
            return [];
        } finally {
            setLoading(false);
        }
    };

    return { getListItems, isLoading };
};

export default useCompanyAutocompleteCustomFetch;
